export const HANDWRITING_FONT = '"LXGW WenKai", "Kaiti SC", "STKaiti", "KaiTi", cursive';

export const TEXT_FONTS = [
  { id: "default", family: "system-ui", zh: "系统字体", en: "System" },
  { id: "handwriting", family: HANDWRITING_FONT, zh: "手写体 · 文楷", en: "Handwriting" },
  { id: "serif", family: "ui-serif, serif", zh: "衬线字体", en: "Serif" },
  { id: "monospace", family: "ui-monospace, monospace", zh: "等宽字体", en: "Monospace" },
] as const;

export type TextFontId = typeof TEXT_FONTS[number]["id"];
export function textFont(value: string | undefined) {
  return TEXT_FONTS.find((font) => font.id === value || font.family === value) ?? TEXT_FONTS[0];
}
